import {
  SET_PRESET_MESSAGES,
  RESET_PRESET_MESSAGES,
} from '../../mutation-types';
import PresetMessagesService from '../../../services/preset-messages-service';

const actions = {
  getPresetMessagesById({ commit }, id) {
    return PresetMessagesService.getById(id).then((res) => {
      commit(SET_PRESET_MESSAGES, res);
    });
  },

  getPresetMessagesByQueue({ commit }, id) {
    return PresetMessagesService.getByQueue(id).then((res) => {
      commit(SET_PRESET_MESSAGES, res.data);
    });
  },

  getPresetMessagesByCampaign({ commit }, id) {
    return PresetMessagesService.getBycampaign(id).then((res) => {
      commit(SET_PRESET_MESSAGES, res.data);
    });
  },

  reset({ commit }) {
    commit(RESET_PRESET_MESSAGES);
  },
};

export default actions;
